var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudSolution({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 239,
    viewBox: "0 0 195 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.438 215.33L7.54329 137.031L7.75049 134.316L102.645 212.615L102.438 215.33Z",
    fill: "url(#paint0_linear_459_1118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.438 215.33L152.076 185.715L152.283 183L102.645 212.615L102.438 215.33Z",
    fill: "url(#paint1_linear_459_1118)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3902 104.675L7.74834 134.341L102.643 212.64L152.281 183.025L57.3902 104.675Z",
    fill: "url(#paint2_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.017 106.273L9.87215 134.478L104.252 209.982L102.586 210.997L104.252 209.982L149.728 182.83L57.017 106.273Z",
    fill: "#3A3469"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8386 159.117L97.1098 131.066L101.112 78.6198L53.8411 106.671L49.8386 159.117Z",
    fill: "url(#paint3_linear_459_1118)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8389 159.117L28.0117 141.179L32.0142 88.7331L53.8414 106.671L49.8389 159.117Z",
    fill: "url(#paint4_linear_459_1118)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2866 60.6697L101.112 78.6323L53.8407 106.683L32.0135 88.7456L79.2866 60.6697Z",
    fill: "url(#paint5_linear_459_1118)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5982 143.729L32.1977 131.078L34.2549 104.121L49.6549 116.778L47.5982 143.729Z",
    fill: "url(#paint6_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5982 143.729L34.484 132.953L34.7179 129.889L49.3153 121.229L47.5982 143.729Z",
    fill: "#47417D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0958 143.314L34.4835 132.953L34.7207 129.845L47.333 140.205L47.0958 143.314Z",
    fill: "url(#paint7_linear_459_1118)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5412 105.997L34.484 132.953L32.1977 131.078L34.2549 104.121L36.5412 105.997Z",
    fill: "url(#paint8_linear_459_1118)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1543 116.339L49.6543 116.778L47.5976 143.729L47.0971 143.295L49.1543 116.339Z",
    fill: "#002B64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6059 117.421L34.2044 104.783L34.2549 104.121L49.6559 116.766L49.6059 117.421Z",
    fill: "#002B64"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5982 143.729L32.1977 131.078L34.2549 104.121L49.6549 116.778L47.5982 143.729Z",
    fill: "#47417D"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0068 102.44L91.6679 80.2155L91.8041 78.4304L54.1431 100.655L54.0068 102.44Z",
    fill: "url(#paint9_linear_459_1118)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0072 102.44L38.7661 89.9201L38.9023 88.1351L54.1434 100.655L54.0072 102.44Z",
    fill: "url(#paint10_linear_459_1118)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5706 65.8989L91.804 78.4367L54.1425 100.667L38.9019 88.1413L76.5706 65.8989Z",
    fill: "url(#paint11_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2604 69.3387L86.7891 79.6423L85.7174 80.2762L73.1825 69.9721L74.2604 69.3387Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3869 70.4387L84.9218 80.7428L83.8439 81.3762L71.309 71.0721L72.3869 70.4387Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5119 71.5637L83.0468 81.8678L81.9689 82.5012L69.434 72.1971L70.5119 71.5637Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5856 76.9091L74.0734 87.1719L72.9956 87.8053L60.5077 77.5425L61.5856 76.9091Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7116 78.0216L72.2124 88.2792L71.134 88.9188L58.6332 78.6612L59.7116 78.0216Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8371 79.1403L70.3657 89.444L69.2941 90.0779L56.7592 79.7737L57.8371 79.1403Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4655 84.6401L61.0004 94.9442L59.922 95.5838L47.3871 85.2797L48.4655 84.6401Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5905 85.7588L59.1254 96.0629L58.0475 96.6963L45.5126 86.3922L46.5905 85.7588Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7165 86.8713L57.2514 97.1755L56.173 97.8151L43.6386 87.5047L44.7165 86.8713Z",
    fill: "#47417D"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8032 109.615L40.4853 111.816L40.4053 112.865L37.7232 110.664L37.8032 109.615Z",
    fill: "#5EBBD8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1593 109.083L37.0793 110.131L36.3233 109.508L36.4028 108.466L37.1593 109.083Z",
    fill: "#5EBBD8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9458 112.197L48.4422 118.356L48.3621 119.404L40.8658 113.245L40.9458 112.197Z",
    fill: "#5EBBD8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5952 112.336L40.2773 114.537L40.1973 115.586L37.5152 113.385L37.5952 112.336Z",
    fill: "#5EBBD8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7383 114.918L48.2346 121.077L48.1546 122.126L40.6583 115.966L40.7383 114.918Z",
    fill: "#5EBBD8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5303 117.639L48.0266 123.798L47.9466 124.847L40.4507 118.681L40.5303 117.639Z",
    fill: "#5EBBD8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1919 117.623L39.874 119.824L39.794 120.872L37.1119 118.671L37.1919 117.623Z",
    fill: "#5EBBD8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.548 117.097L36.4685 118.139L35.7124 117.516L35.792 116.474L36.548 117.097Z",
    fill: "#5EBBD8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3345 120.204L47.8304 126.37L47.7508 127.412L40.2545 121.253L40.3345 120.204Z",
    fill: "#5EBBD8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9839 120.344L39.666 122.545L39.586 123.594L36.9043 121.386L36.9839 120.344Z",
    fill: "#5EBBD8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1265 122.925L47.6228 129.085L47.5428 130.133L40.0469 123.968L40.1265 122.925Z",
    fill: "#5EBBD8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9194 125.647L47.4158 131.806L47.3358 132.854L39.8399 126.689L39.9194 125.647Z",
    fill: "#5EBBD8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5806 125.63L39.2622 127.838L39.1827 128.88L36.5005 126.679L36.5806 125.63Z",
    fill: "#5EBBD8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9367 125.104L35.8571 126.146L35.1011 125.524L35.1807 124.481L35.9367 125.104Z",
    fill: "#5EBBD8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7236 128.212L47.2195 134.377L47.14 135.42L39.6436 129.26L39.7236 128.212Z",
    fill: "#5EBBD8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3726 128.352L39.0547 130.553L38.9746 131.601L36.2925 129.4L36.3726 128.352Z",
    fill: "#5EBBD8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5156 130.933L47.012 137.092L46.932 138.141L39.4361 131.975L39.5156 130.933Z",
    fill: "#5EBBD8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3086 133.654L46.805 139.814L46.7249 140.862L39.2286 134.703L39.3086 133.654Z",
    fill: "#5EBBD8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0628 199.008C101.06 197.767 114.149 190.109 119.429 186.983C119.955 186.672 120.567 186.298 120.962 186.058C122.264 185.291 122.06 182.941 122.06 182.941L98.7432 196.78L98.5607 199.17C98.5607 199.17 98.7792 199.187 99.069 199.008L99.0628 199.008Z",
    fill: "url(#paint12_linear_459_1118)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1249 198.961C95.4784 196.788 70.8047 176.417 62.3218 169.448C61.1224 168.465 61.6699 166.31 61.6699 166.31L98.7439 196.774L98.5615 199.164C98.4554 199.156 98.2786 199.086 98.1312 198.962L98.1249 198.961Z",
    fill: "url(#paint13_linear_459_1118)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0103 152.491L122.06 182.941L98.7434 196.78L61.6694 166.316L85.0103 152.491Z",
    fill: "url(#paint14_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0045 154.129L119.311 182.354L106.499 189.996L106.499 190.002L106.499 189.996L72.1737 161.769L85.0045 154.129Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0721 171.74L93.2925 181.09L86.5574 185.109L75.325 175.752L82.0721 171.74Z",
    fill: "white"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M122.06 182.941C122.06 182.941 123.387 182.992 123.49 181.637L125.443 156.048C125.464 155.767 125.289 155.352 125.289 155.352L124.118 155.884L122.054 182.934L122.06 182.941Z",
    fill: "url(#paint15_linear_459_1118)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M122.06 182.941L85.0411 152.493L87.1055 125.443L124.124 155.89L122.06 182.941Z",
    fill: "url(#paint16_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M122.06 182.941L85.0411 152.493L87.1055 125.443L124.124 155.89L122.06 182.941Z",
    fill: "#47417D"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8992 126.021C98.0171 132.673 121.323 151.885 124.724 154.612C125.192 154.986 125.289 155.352 125.289 155.352L124.118 155.89L87.0995 125.443C87.0995 125.443 88.1384 124.581 89.8934 126.014L89.8992 126.021Z",
    fill: "url(#paint17_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M120.72 179.85L86.3528 151.595L88.1309 128.296L122.498 156.551L120.72 179.85Z",
    fill: "#594E83"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.39
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.892 141.32L122.404 156.544L120.626 179.843L86.389 151.692L103.892 141.32Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.39
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M120.804 179.825L87.66 152.568L97.8663 146.498L121.842 166.219L120.804 179.825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.39
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.893 163.241L111.27 154.382L116.202 151.444L122.404 156.544L121.893 163.241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M102.526 195.248L99.422 197.102L99.3524 198.013L102.457 196.153L102.526 195.248Z",
    fill: "#47417D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M106.566 192.832L103.461 194.685L103.391 195.597L106.496 193.743L106.566 192.832Z",
    fill: "#47417D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M115.776 187.383L108.017 191.988L107.948 192.9L115.707 188.288L115.776 187.383Z",
    fill: "#47417D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M121.319 184.096L118.22 185.956L118.151 186.867L121.25 185.007L121.319 184.096Z",
    fill: "#47417D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M148.364 142.379C148.634 138.601 146.051 131.643 142.274 128.568C140.661 127.252 139.166 126.843 137.958 127.133C137.958 127.133 137.495 127.28 137.351 127.351C137.188 127.426 136.75 127.738 136.75 127.738C136.591 122.095 132.961 113.067 127.859 108.923C125.01 106.609 122.423 106.374 120.526 107.453C120.171 107.659 118.75 108.517 117.124 109.51C115.999 107.139 114.491 104.934 112.741 103.513C111.482 102.488 110.291 101.976 109.236 101.896C108.462 101.837 106.607 102.7 105.304 103.492C104.738 103.832 104.192 104.16 103.652 104.489C103.678 104.479 103.698 104.462 103.718 104.45C103.058 103.302 102.246 102.097 101.505 101.444C100.029 100.132 98.7706 100.174 97.8843 100.848L94.7567 102.674L86.5938 40.511L186.084 122.268L146.981 145.864C147.75 145 148.252 143.77 148.351 142.384L148.364 142.379Z",
    fill: "url(#paint18_linear_459_1118)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M110.749 113.33C110.749 113.33 110.737 113.329 110.73 113.341C110.73 113.341 110.742 113.342 110.742 113.336C110.742 113.336 110.746 113.336 110.754 113.337L110.749 113.33Z",
    fill: "url(#paint19_linear_459_1118)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M113.81 113.036C113.841 113.039 113.871 113.047 113.902 113.056C113.871 113.054 113.841 113.039 113.81 113.036Z",
    fill: "url(#paint20_linear_459_1118)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1152 106.543L97.8786 100.847C98.7649 100.174 100.017 100.131 101.499 101.45C102.24 102.103 103.052 103.307 103.711 104.456C101.42 105.851 99.3567 107.143 97.414 108.251C97.5177 108.208 97.6338 108.167 97.7428 108.138C96.1069 108.597 95.1397 110.413 94.9551 113.079C94.9479 113.173 94.9403 113.272 94.9327 113.372C94.2496 111.217 92.9876 108.917 91.4092 107.636C91.2675 107.518 91.1311 107.413 90.9875 107.321C90.9813 107.32 90.9698 107.307 90.9578 107.3C90.8266 107.208 90.6941 107.135 90.5615 107.062C90.5495 107.055 90.5318 107.041 90.5193 107.04C90.3925 106.974 90.2715 106.915 90.15 106.861C90.1313 106.86 90.1135 106.846 90.0953 106.838C89.9733 106.791 89.8571 106.751 89.7404 106.717C89.7217 106.716 89.7034 106.708 89.6914 106.701C89.5743 106.673 89.4629 106.652 89.351 106.637C89.3323 106.636 89.3198 106.635 89.3011 106.633C89.195 106.625 89.0826 106.617 88.9756 106.621C88.9631 106.62 88.9506 106.619 88.9381 106.618C88.8311 106.623 88.7235 106.633 88.6213 106.657C88.6088 106.656 88.6088 106.656 88.5958 106.661C88.4936 106.685 88.3909 106.715 88.2877 106.751C87.8668 106.919 87.5107 107.225 87.234 107.643C87.163 107.751 87.104 107.866 87.045 107.98C87.045 107.98 87.045 107.981 87.0445 107.987C86.9851 108.108 86.9314 108.235 86.8839 108.364C86.8355 108.504 86.7934 108.646 86.757 108.793C86.757 108.793 86.757 108.793 86.7565 108.8C86.7201 108.948 86.6895 109.102 86.6708 109.264C86.7987 107.918 87.331 106.948 88.1229 106.525L88.1152 106.543Z",
    fill: "url(#paint21_linear_459_1118)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6671 108.165C99.6671 108.165 99.6547 108.164 99.6484 108.164C99.4882 108.127 99.3337 108.096 99.1787 108.072C99.3399 108.096 99.5006 108.128 99.6671 108.165Z",
    fill: "url(#paint22_linear_459_1118)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1107 108.06C98.9614 108.042 98.8116 108.031 98.6676 108.026C98.8116 108.031 98.9552 108.042 99.1107 108.06Z",
    fill: "url(#paint23_linear_459_1118)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 133.93C126.667 133.93 126.668 133.911 126.669 133.899L126.912 133.755C126.832 133.811 126.753 133.868 126.673 133.93L126.667 133.93Z",
    fill: "url(#paint24_linear_459_1118)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M138.275 148.565C138.544 144.793 135.968 137.829 132.191 134.76C130.17 133.118 128.342 132.878 127.025 133.682L136.731 127.749C136.731 127.749 137.169 127.444 137.326 127.361C137.476 127.291 137.933 127.144 137.933 127.144C139.142 126.847 140.636 127.262 142.249 128.572C146.027 131.641 148.609 138.606 148.34 142.377C148.208 144.275 147.326 145.878 146.024 146.645L146.005 146.656C146.005 146.656 145.992 146.661 145.991 146.667L137.015 151.921C137.727 151.065 138.181 149.888 138.276 148.558L138.275 148.565Z",
    fill: "url(#paint25_linear_459_1118)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6093 109.736C86.8212 106.796 88.9035 105.586 91.4218 107.63C93.0001 108.912 94.2622 111.212 94.9453 113.367C94.9529 113.267 94.96 113.174 94.9676 113.074C95.3013 108.372 98.0462 106.296 102.67 109.7C104.899 111.346 106.607 114.383 107.762 117.346C109.05 112.73 113.085 111.261 117.832 115.114C122.928 119.257 126.52 128.282 126.68 133.925C128.012 132.84 129.993 132.96 132.203 134.755C135.981 137.824 138.557 144.788 138.288 148.559C138.047 151.962 135.424 154.418 132.257 152.814L90.2888 118.693L90.1826 118.603C87.8659 116.468 86.4253 112.723 86.6347 109.732L86.6093 109.736Z",
    fill: "url(#paint26_linear_459_1118)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M105.291 103.497C106.6 102.712 108.455 101.849 109.229 101.908C110.283 101.988 111.475 102.5 112.734 103.525C114.484 104.946 115.985 107.151 117.116 109.522C114.423 111.162 111.163 113.167 111.163 113.167C111.163 113.167 111.175 113.168 111.182 113.169C111.04 113.221 110.891 113.278 110.754 113.343C110.754 113.343 110.748 113.343 110.742 113.342L110.729 113.347C110.729 113.347 110.689 113.37 110.67 113.374C110.396 113.51 110.132 113.679 109.885 113.867C109.859 113.89 109.832 113.907 109.805 113.93C109.685 114.027 109.57 114.132 109.455 114.242C109.339 114.359 109.23 114.476 109.126 114.606C109.099 114.636 109.077 114.665 109.056 114.695C108.952 114.825 108.854 114.956 108.762 115.093C108.67 115.231 108.577 115.38 108.49 115.537C108.468 115.573 108.453 115.61 108.431 115.652C108.344 115.808 108.269 115.966 108.194 116.13C108.118 116.293 108.048 116.47 107.985 116.647C107.969 116.69 107.952 116.739 107.937 116.782C107.872 116.965 107.808 117.149 107.755 117.345C106.601 114.382 104.899 111.346 102.664 109.7C102.623 109.665 102.581 109.637 102.539 109.615C100.408 108.078 98.6847 107.714 97.42 108.245C99.7966 106.882 102.356 105.257 105.297 103.491L105.291 103.497Z",
    fill: "url(#paint27_linear_459_1118)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M117.82 115.119C116.643 114.163 115.517 113.537 114.457 113.199C114.457 113.199 113.136 112.74 111.158 113.154C111.158 113.154 119.569 107.995 120.514 107.459C122.41 106.379 124.998 106.614 127.841 108.928C132.936 113.071 136.572 122.1 136.732 127.737L126.665 133.868C126.481 128.222 122.898 119.242 117.82 115.113L117.82 115.119Z",
    fill: "url(#paint28_linear_459_1118)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 41.0655L127.715 46.1727L127.53 48.5944L121.316 43.4872L121.5 41.0655Z",
    fill: "#8B87BC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M120 39.8273L119.815 42.2552L118.054 40.8088L118.239 38.3872L120 39.8273Z",
    fill: "#8B87BC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M128.79 47.052L146.186 61.3557L146.001 63.7773L128.605 49.4799L128.79 47.052Z",
    fill: "#8B87BC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M121.019 47.3818L127.233 52.489L127.048 54.9106L120.834 49.8034L121.019 47.3818Z",
    fill: "#8B87BC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M128.309 53.3683L145.705 67.6719L145.52 70.0936L128.123 55.7962L128.309 53.3683Z",
    fill: "#8B87BC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M127.826 59.6845L145.222 73.9882L145.038 76.4098L127.641 62.1062L127.826 59.6845Z",
    fill: "#8B87BC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M120.083 59.6523L126.297 64.7595L126.112 67.1873L119.898 62.0739L120.083 59.6523Z",
    fill: "#8B87BC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M118.582 58.4203L118.397 60.842L116.636 59.4018L116.821 56.9739L118.582 58.4203Z",
    fill: "#8B87BC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M127.372 65.6451L144.768 79.9424L144.583 82.3703L127.187 68.0667L127.372 65.6451Z",
    fill: "#8B87BC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M119.6 65.9685L125.814 71.0757L125.629 73.5036L119.415 68.3902L119.6 65.9685Z",
    fill: "#8B87BC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M126.89 71.9613L144.286 86.2587L144.102 88.6804L126.705 74.383L126.89 71.9613Z",
    fill: "#8B87BC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M126.407 78.2776L143.803 92.575L143.619 94.9966L126.222 80.6992L126.407 78.2776Z",
    fill: "#8B87BC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M118.664 78.239L124.877 83.3525L124.693 85.7741L118.478 80.6669L118.664 78.239Z",
    fill: "#8B87BC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.163 77.0071L116.978 79.435L115.218 77.9886L115.402 75.5669L117.163 77.0071Z",
    fill: "#8B87BC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M125.953 84.2318L143.349 98.5354L143.164 100.957L125.768 86.6535L125.953 84.2318Z",
    fill: "#8B87BC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M118.181 84.5553L124.395 89.6687L124.21 92.0904L117.996 86.9832L118.181 84.5553Z",
    fill: "#8B87BC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M125.471 90.5481L142.867 104.845L142.682 107.273L125.286 92.9697L125.471 90.5481Z",
    fill: "#8B87BC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M124.989 96.8643L142.386 111.162L142.2 113.59L124.804 99.286L124.989 96.8643Z",
    fill: "#8B87BC"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M83.0401 11.3999L35.8057 39.0519L32.0142 88.7331L79.2834 60.6255L83.0401 11.3999Z",
    fill: "url(#paint29_linear_459_1118)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M71.959 6.56165L65.0415 10.6667L64.8567 13.0883L71.7742 8.98329L71.959 6.56165Z",
    fill: "#8B87BC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6294 5.56544L73.4442 7.99333L75.3974 6.83035L75.5822 4.40871L73.6294 5.56544Z",
    fill: "#8B87BC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8455 11.3727L44.474 22.8703L44.2891 25.292L63.6603 13.8006L63.8455 11.3727Z",
    fill: "#8B87BC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M71.477 12.8779L64.5596 16.983L64.3748 19.4046L71.2922 15.2996L71.477 12.8779Z",
    fill: "#8B87BC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3631 17.6889L43.9915 29.1866L43.8067 31.6082L63.1778 20.1168L63.3631 17.6889Z",
    fill: "#8B87BC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8807 24.0052L43.5091 35.5028L43.3243 37.9245L62.6954 26.4331L62.8807 24.0052Z",
    fill: "#8B87BC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5405 25.1484L63.6226 29.2597L63.4378 31.6814L70.3552 27.5763L70.5405 25.1484Z",
    fill: "#8B87BC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M72.211 24.1585L72.0262 26.5801L73.9789 25.4234L74.1642 22.9955L72.211 24.1585Z",
    fill: "#8B87BC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4261 29.9657L43.055 41.4571L42.8697 43.885L62.2413 32.3873L62.4261 29.9657Z",
    fill: "#8B87BC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0586 31.4647L63.1412 35.5697L62.9559 37.9976L69.8738 33.8863L70.0586 31.4647Z",
    fill: "#8B87BC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9442 36.2819L42.5731 47.7734L42.3878 50.2013L61.7594 38.7036L61.9442 36.2819Z",
    fill: "#8B87BC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4627 42.5982L42.0916 54.0896L41.9068 56.5113L61.2779 45.0199L61.4627 42.5982Z",
    fill: "#8B87BC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1225 43.7352L62.2046 47.8465L62.0198 50.2681L68.9373 46.1631L69.1225 43.7352Z",
    fill: "#8B87BC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7925 42.7452L70.6072 45.1731L72.5605 44.0101L72.7453 41.5885L70.7925 42.7452Z",
    fill: "#8B87BC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0081 48.5524L41.6366 60.0501L41.4517 62.4718L60.8228 50.9803L61.0081 48.5524Z",
    fill: "#8B87BC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6406 50.0515L61.7227 54.1627L61.5379 56.5844L68.4553 52.4794L68.6406 50.0515Z",
    fill: "#8B87BC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5262 54.8687L41.1551 66.3601L40.9698 68.788L60.3414 57.2903L60.5262 54.8687Z",
    fill: "#8B87BC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0438 61.185L40.6722 72.6826L40.4874 75.1043L59.859 63.6066L60.0438 61.185Z",
    fill: "#8B87BC"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2722 201.673L100.057 197.74L106.828 201.886L96.9512 207.592C95.4204 208.567 93.2417 207.748 92.2667 206.211C91.2912 204.68 91.7418 202.643 93.2726 201.667L93.2722 201.673Z",
    fill: "#09003C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6859 227.884C89.0807 228.141 90.0548 228.29 90.8635 227.812C92.0604 227.1 94.545 225.802 94.5621 225.577L94.7674 222.887L91.0164 222.601C91.0164 222.601 90.9144 223.936 90.9073 224.03C90.8963 224.173 90.8362 224.715 90.5219 224.967C90.0737 225.329 89.8295 225.567 89.0992 226.171C88.3348 226.809 88.2085 227.559 88.6926 227.879L88.6859 227.884Z",
    fill: "#09003C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9091 223.923L91.4885 204.733C91.5994 203.278 92.8696 202.183 94.3238 202.294C95.778 202.405 96.8739 203.675 96.7624 205.135L96.8494 207.615L94.6025 225.046L90.9091 223.923Z",
    fill: "#09003C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4537 205.213L104.232 201.279L111.024 201.54C111.024 201.54 111.127 202.986 111.209 203.971C111.297 205.033 110.549 205.704 109.104 206.548C107.448 207.52 101.127 211.131 101.127 211.131C99.5957 212.106 97.417 211.287 96.442 209.75C95.4665 208.219 95.9171 206.182 97.4479 205.206L97.4537 205.213Z",
    fill: "#09003C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8661 231.43C93.2608 231.686 94.235 231.836 95.0437 231.358C96.2406 230.646 98.7252 229.347 98.7423 229.123L98.9476 226.433L95.1965 226.146C95.1965 226.146 95.0946 227.482 95.0875 227.576C95.0765 227.719 95.0164 228.261 94.7021 228.513C94.2539 228.874 94.0101 229.107 93.2793 229.717C92.5149 230.355 92.3882 231.111 92.8728 231.424L92.8661 231.43Z",
    fill: "#09003C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0892 227.463L95.6686 208.272C95.7796 206.818 97.0493 205.728 98.5097 205.84C99.9702 205.951 101.06 207.221 100.949 208.675L101.036 211.155L98.7889 228.586L95.0955 227.463L95.0892 227.463Z",
    fill: "#09003C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M110.809 177.374L105.002 176.805L105.304 186.414L110.809 177.374Z",
    fill: "#928CBE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M105.002 176.805L105.304 186.414L104.28 199.833C104.28 199.833 104.138 201.693 102.711 201.144C101.028 200.495 100.261 198.779 100.285 198.053C100.466 193.377 100.467 193.453 101.088 185.314L101.581 178.86L105.008 176.805L105.002 176.805Z",
    fill: "#25216F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M105.305 186.414L110.816 177.374C112.682 178.91 115.083 180.77 115.083 180.77L112.58 188.884L111.071 195.498C111.071 195.498 111.249 200.823 111.296 203.827C111.317 205.361 106.906 204.993 105.112 203.167C104.32 202.36 104.208 200.869 104.304 199.609L105.311 186.408L105.305 186.414Z",
    fill: "#25216F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M106.543 170.337C106.984 170.151 107.718 170.082 108.248 170.122C109.877 170.246 110.891 171.849 110.767 173.478L110.602 175.644C110.522 176.686 108.119 178.236 106.699 178.41C106.414 178.444 106.249 178.388 106.165 178.331C105.98 178.21 105.827 177.91 105.801 177.839C105.68 177.535 105.663 176.937 105.663 176.937L106.543 170.337Z",
    fill: "#E39E76"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M108.501 167.059C110.504 167.212 111.748 169.178 111.595 171.181L111.487 172.592C111.316 174.832 107.846 177.537 105.848 177.384C104.85 177.308 104.748 176.089 104.437 174.822C104.212 173.901 104.534 171.333 104.618 170.228C104.771 168.224 106.504 166.907 108.507 167.059L108.501 167.059Z",
    fill: "#F5BB95"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M110.725 173.299C110.401 173.833 110.394 174.417 110.7 174.603C111.006 174.79 111.518 174.502 111.841 173.968C112.158 173.434 112.171 172.851 111.865 172.664C111.559 172.478 111.048 172.765 110.731 173.3L110.725 173.299Z",
    fill: "#F5BB95"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M110.603 175.644C110.603 175.644 110.423 176.434 109.484 177.065C108.538 177.696 106.896 178.726 106.166 178.331L107.685 179.816C107.685 179.816 110.753 178.11 110.822 177.211C110.891 176.313 110.947 175.984 110.596 175.644L110.603 175.644Z",
    fill: "#B2AFD4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M105.687 177.366C105.687 177.366 105.728 177.984 106.16 178.331L105.061 178.988L105.002 176.805C105.002 176.805 105.251 177.238 105.687 177.366Z",
    fill: "#B2AFD4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M109.297 170.202L111.244 169.12C111.523 169.744 111.65 170.463 111.596 171.181L111.488 172.592C111.488 172.592 111.486 172.623 111.485 172.635C110.817 172.823 110.534 173.737 110.534 173.737L110.044 173.329L110.112 172.443C109.383 172.293 108.869 170.967 108.68 170.4C109.065 170.291 109.298 170.196 109.298 170.196L109.297 170.202Z",
    fill: "#09003C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M104.57 170.438C104.576 170.363 104.581 170.294 104.587 170.226C104.74 168.222 106.472 166.904 108.476 167.057C109.78 167.157 110.806 167.869 111.244 169.12L109.297 170.202C109.297 170.202 106.714 171.229 104.571 170.432L104.57 170.438Z",
    fill: "#09003C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M105.711 179.514L105.784 178.56L106.166 178.331L107.276 179.414L106.438 180.11L105.711 179.514Z",
    fill: "#191454"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M106.438 180.11L106.604 184.278L105.304 186.414L105.186 183.109L105.712 179.514L106.438 180.11Z",
    fill: "#191454"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M108.603 186.289L111.872 178.252L111.176 177.665L105.304 186.414L108.603 186.289Z",
    fill: "#191454"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M105.304 186.414L102.844 181.882L104.08 177.287L105.002 176.805L105.304 186.414Z",
    fill: "#191454"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M105.304 186.414L108.306 185.978L111.872 178.252L110.809 177.374L105.304 186.414Z",
    fill: "#25216F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M105.304 186.414L103.214 181.791L104.079 177.287C104.079 177.287 104.505 176.974 105.001 176.805L105.304 186.414Z",
    fill: "#25216F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M110.555 201.505C108.833 201.373 109.457 199.77 110.101 199.649C110.445 199.581 110.632 199.602 111.137 199.314C111.353 199.193 111.381 198.912 111.167 198.915L111.146 198.285C111.358 198.226 111.71 198.146 112.022 198.076C113.006 197.862 113.717 197.502 114.038 198.067C114.774 199.366 113.077 201.691 110.55 201.498L110.555 201.505Z",
    fill: "#F5BB95"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M113.967 200.239C113.967 200.239 118.097 197.209 121.815 194.881C122.514 194.438 122.889 192.822 122.453 192.123C121.441 190.496 118.142 184.851 115.465 181.106C113.61 178.51 111.39 178.899 110.625 179.62C109.124 181.03 110.807 182.427 112.443 184.674C113.96 186.754 115.813 189.871 117.152 192.321C117.344 192.681 117.311 193.2 117.049 193.419C114.779 195.279 111.796 197.682 111.796 197.682C111.796 197.682 112.295 199.691 113.967 200.239Z",
    fill: "#25216F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0137 186.121L101.593 178.861L101.195 184.085L93.1148 189.602C92.154 190.181 90.9032 189.873 90.3231 188.918C89.7436 187.957 90.0525 186.706 91.0133 186.127L91.0137 186.121Z",
    fill: "#25216F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M100.46 193.295C101.496 194.127 101.673 195.252 101.673 195.252C101.77 195.712 101.855 196.578 101.514 197.757C101.462 197.942 101.283 198.06 101.102 198.046C101.077 198.044 101.046 198.042 101.022 198.034C100.862 197.99 100.759 197.857 100.739 197.704C100.739 197.704 100.739 197.704 100.739 197.711C100.687 197.895 100.508 198.013 100.327 198C100.303 197.998 100.271 197.995 100.247 197.987C100.093 197.944 99.9899 197.817 99.9634 197.67C99.9006 197.835 99.7417 197.942 99.5607 197.928C99.5358 197.927 99.5046 197.924 99.4801 197.916C99.3264 197.873 99.2174 197.739 99.1976 197.587C99.1976 197.587 99.1976 197.587 99.1971 197.593C99.1454 197.777 98.9669 197.896 98.7859 197.882C98.7609 197.88 98.7297 197.878 98.7052 197.869C98.4963 197.81 98.3752 197.587 98.4351 197.378C98.6411 196.653 98.6662 196.077 98.6405 195.674C98.6129 195.376 98.5734 195.154 98.5177 194.98L100.467 193.296L100.46 193.295Z",
    fill: "#F5BB95"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4842 186.639C91.153 185.855 92.3339 185.763 93.1178 186.432L100.766 193.312L98.0705 195.404L90.6918 189.266C89.9079 188.598 89.8159 187.417 90.4909 186.633L90.4842 186.639Z",
    fill: "#25216F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6512 95.1451L63.0382 90.6299L56.313 93.4502L64.4884 100.007C65.7416 101.107 67.8345 100.664 68.9346 99.4105C70.0347 98.1573 69.9044 96.2452 68.6512 95.1451Z",
    fill: "#09003C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1592 119.585C68.769 119.763 67.8588 119.762 67.1911 119.215C66.2045 118.406 64.1301 116.879 64.1459 116.673L64.3345 114.201L67.7797 114.464C67.7797 114.464 67.6863 115.687 67.6797 115.775C67.6697 115.906 67.6503 116.407 67.8991 116.683C68.2585 117.075 68.4406 117.321 69.0185 117.974C69.6253 118.66 69.6281 119.364 69.1467 119.584L69.1592 119.585Z",
    fill: "#09003C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6937 115.675L69.8397 98.1675C69.9416 96.8318 68.9385 95.6629 67.6028 95.561C66.2672 95.4591 65.0983 96.4622 64.9964 97.7979L64.5681 100.038L64.1837 116.18L67.6937 115.675Z",
    fill: "#09003C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3638 97.7747L58.7508 93.2596L52.5525 92.548C52.5525 92.548 52.2523 93.8497 52.0406 94.7312C51.8112 95.6805 52.3969 96.3969 53.5972 97.3674C54.9685 98.4827 60.2005 102.642 60.2005 102.642C61.4537 103.742 63.5466 103.3 64.6472 102.04C65.7473 100.787 65.6232 98.8752 64.3638 97.7747Z",
    fill: "#09003C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8701 122.221C64.4799 122.399 63.5697 122.398 62.902 121.851C61.9155 121.041 59.8411 119.515 59.8568 119.309L60.0454 116.837L63.4906 117.1C63.4906 117.1 63.3973 118.323 63.3906 118.411C63.3806 118.542 63.3612 119.042 63.6101 119.319C63.9694 119.71 64.1578 119.957 64.7357 120.61C65.3425 121.297 65.3515 122 64.8639 122.221L64.8701 122.221Z",
    fill: "#09003C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4046 118.311L65.5506 100.803C65.6525 99.4676 64.6494 98.2987 63.3138 98.1968C61.9781 98.0949 60.8092 99.098 60.7073 100.434L60.279 102.673L59.8946 118.816L63.4046 118.311Z",
    fill: "#09003C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M56.114 70.6344L61.4652 70.9298L59.8544 79.6145L56.114 70.6344Z",
    fill: "#928CBE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4654 70.9297L59.8547 79.6144L58.914 91.9411C58.914 91.9411 58.7834 93.6513 60.1558 93.3542C61.7773 93.0009 62.7107 91.5466 62.7861 90.8869C63.2752 86.6177 63.2637 86.6859 63.8343 79.2088L64.2868 73.2795L61.4587 70.9355L61.4654 70.9297Z",
    fill: "#25216F"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8551 79.6143L56.1142 70.6405C54.207 71.7756 51.7686 73.1275 51.7686 73.1275L52.9062 80.8418L53.3545 87.0595C53.3545 87.0595 52.4477 91.8681 51.9889 94.589C51.7574 95.9776 55.8099 96.2617 57.7006 94.8491C58.5327 94.2284 58.842 92.8897 58.9301 91.7351L59.8556 79.6081L59.8551 79.6143Z",
    fill: "#25216F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9702 64.8402C60.5923 64.6105 59.933 64.4472 59.4524 64.4105C57.9545 64.2962 56.8122 65.6089 56.6979 67.1069L56.546 69.0979C56.4731 70.0528 58.4367 71.7972 59.6967 72.1507C59.9488 72.2202 60.1077 72.1946 60.1926 72.1509C60.3812 72.0649 60.5573 71.8146 60.5932 71.7546C60.7448 71.4962 60.8424 70.9575 60.8424 70.9575L60.964 64.8397L60.9702 64.8402Z",
    fill: "#E39E76"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6481 61.5942C57.8069 61.4537 56.4032 63.0667 56.2632 64.9016L56.1641 66.1998C56.0069 68.2595 58.7773 71.1954 60.6185 71.3359C61.536 71.4059 61.7951 70.3146 62.2567 69.201C62.588 68.3976 62.6566 66.0173 62.7338 65.0062C62.8738 63.1712 61.4836 61.728 59.6424 61.5875L59.6481 61.5942Z",
    fill: "#F5BB95"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M56.76 66.9484C56.9769 67.4797 56.9052 68.0078 56.6004 68.1353C56.2956 68.2627 55.8753 67.9293 55.6585 67.3979C55.4417 66.8666 55.5134 66.3385 55.8181 66.2111C56.1229 66.0837 56.5494 66.4175 56.7605 66.9422L56.76 66.9484Z",
    fill: "#F5BB95"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5457 69.0916C56.5457 69.0916 56.5961 69.8299 57.3647 70.5352C58.1332 71.2404 59.482 72.4043 60.1986 72.1451L58.6116 73.2795C58.6116 73.2795 56.0631 71.3022 56.126 70.4783C56.1889 69.6545 56.181 69.3463 56.5462 69.0853L56.5457 69.0916Z",
    fill: "#B2AFD4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7624 71.3406C60.7624 71.3406 60.6442 71.9029 60.1983 72.1514L61.108 72.8988L61.4655 70.9298C61.4655 70.9298 61.1805 71.2909 60.7624 71.3406Z",
    fill: "#B2AFD4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4843 64.3367L56.8662 63.0832C56.5242 63.6158 56.3128 64.2463 56.2624 64.9079L56.1633 66.2061C56.1633 66.2061 56.1614 66.231 56.1604 66.2435C56.7429 66.5077 56.8712 67.3775 56.8712 67.3775L57.3775 67.0772L57.4394 66.2658C58.1201 66.2299 58.7714 65.0994 59.0222 64.61C58.6884 64.459 58.4838 64.3429 58.4838 64.3429L58.4843 64.3367Z",
    fill: "#09003C"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M62.743 65.2078L62.7578 65.0144C62.8978 63.1794 61.5076 61.7361 59.6664 61.5956C58.4681 61.5042 57.4376 62.0094 56.866 63.0832L58.4842 64.3367C58.4842 64.3367 60.689 65.6349 62.743 65.2078Z",
    fill: "#09003C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4442 73.2938L60.5114 72.4138L60.1987 72.1514L59.0369 72.9792L59.7013 73.7331L60.4442 73.2938Z",
    fill: "#191454"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7009 73.733L58.9687 77.4877L59.8547 79.6144L60.4214 76.6318L60.4438 73.2938L59.7009 73.733Z",
    fill: "#191454"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8725 79.0416L55.0224 71.2855L55.7399 70.8506L59.8547 79.6144L56.8725 79.0416Z",
    fill: "#191454"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8547 79.6144L62.7228 75.8407L62.2382 71.4972L61.4654 70.9297L59.8547 79.6144Z",
    fill: "#191454"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8547 79.6144L57.1859 78.8018L55.0224 71.2855L56.1142 70.6344L59.8547 79.6144Z",
    fill: "#25216F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8551 79.6145L62.3943 75.7089L62.2323 71.4968C62.2323 71.4968 61.8946 71.1508 61.4595 70.9293L59.8488 79.614L59.8551 79.6145Z",
    fill: "#25216F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1429 84.2136C66.8163 81.5834 66.7 78.9944 66.3372 76.9202C65.8083 73.8979 65.0266 73.7754 64.2808 73.2665L63.2734 86.467L64.8834 87.0858C66.5204 87.6816 67.4178 86.369 67.1434 84.2073L67.1429 84.2136Z",
    fill: "#1A1556"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7742 87.0398L57.2698 84.2762L58.0114 82.3741L65.707 84.5246L64.7742 87.0398Z",
    fill: "#1A1556"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9998 85.4962C60.9998 85.4962 62.7578 83.7659 63.0663 84.2477C63.0663 84.2477 63.0337 83.6049 62.7478 83.1562C62.3884 82.6014 61.8079 82.5571 61.1701 82.9354C60.5328 83.3073 60.1254 83.5462 60.1254 83.5462L60.9993 85.5025L60.9998 85.4962Z",
    fill: "#F5BB95"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1548 86.0165C61.1548 86.0165 57.6697 87.3451 55.0697 88.2641C54.3536 88.5171 53.6202 88.0091 53.289 87.3309C52.654 86.0269 51.0755 82.7739 50.5 79.7857C49.9076 76.6896 50.349 73.8669 51.3712 73.223C53.7712 71.7174 54.4629 74.7458 54.9555 77.2569C55.3114 79.092 55.336 83.2937 55.6256 84.27C55.7363 84.63 55.9101 84.7374 56.2116 84.6537C58.0994 84.1009 60.3254 83.0655 60.3254 83.0655C60.3254 83.0655 61.5317 84.4508 61.1486 86.0161L61.1548 86.0165Z",
    fill: "#25216F"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9404 82.5633C57.7512 82.4924 56.1258 81.9101 54.3883 81.8089C54.226 81.7965 54.0849 81.9175 54.0788 82.0803C54.0664 82.2426 54.1879 82.3774 54.3502 82.3898C54.5125 82.4022 55.1962 82.5736 55.3513 82.598C55.2745 82.6173 55.191 82.6423 55.1132 82.674C54.9582 82.7312 54.8829 82.895 54.9402 83.05C54.9974 83.205 55.1611 83.2803 55.3162 83.2231C55.3483 83.213 55.3738 83.2087 55.3997 83.1981C55.3474 83.2255 55.2951 83.2529 55.2423 83.2865C55.1036 83.3764 55.071 83.5559 55.1547 83.6941C55.2051 83.7733 55.2896 83.8175 55.377 83.8241C55.4394 83.8289 55.5033 83.8149 55.5628 83.7755C55.6089 83.7476 55.6549 83.7198 55.7005 83.6981C55.6473 83.738 55.5998 83.7846 55.5523 83.8312C55.4366 83.9479 55.4415 84.1304 55.552 84.2455C55.6044 84.2997 55.6654 84.3232 55.734 84.3285C55.8152 84.3347 55.8992 84.3034 55.9663 84.2458C56.0887 84.1233 56.2211 84.0329 56.3584 83.9618C56.2787 84.0185 56.1991 84.0752 56.1309 84.1453C56.0158 84.2558 56.0077 84.4435 56.1182 84.5587C56.1706 84.6129 56.2373 84.6431 56.306 84.6483C56.3871 84.6545 56.4644 84.629 56.5316 84.5714C56.748 84.3682 57.034 84.2394 57.3283 84.1676L57.9519 82.5768L57.9404 82.5633Z",
    fill: "#F5BB95"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6722 176.525C49.6341 177.024 47.57 188.687 46.8242 192.209C46.1061 195.613 44.4574 204.138 44.2192 207.259C44.2054 207.44 43.5187 207.883 42.4544 208.009C41.7324 208.092 40.6432 207.394 40.6613 207.157L43.2498 176.035L49.6659 176.524L49.6722 176.525Z",
    fill: "#09003C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3408 206.507L46.0246 206.712C49.2327 206.957 46.7525 209.266 44.4557 209.091L41.3288 208.852C41.3288 208.852 40.5414 208.805 40.5862 208.218L40.7319 206.308L43.3471 206.508L43.3408 206.507Z",
    fill: "#09003C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M55.532 176.972C55.4356 177.906 55.3462 179.406 55.1885 181.472C54.8527 185.872 53.8733 192.044 53.1274 195.565C52.4093 198.969 50.1177 207.445 49.8796 210.566C49.8658 210.747 49.179 211.19 48.1148 211.316C47.3928 211.399 46.3098 210.701 46.3279 210.464L48.9848 176.472L55.5382 176.972L55.532 176.972Z",
    fill: "#09003C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0018 209.815L51.6856 210.019C54.8937 210.264 52.4135 212.573 50.1105 212.398L46.9836 212.159C46.9836 212.159 46.1962 212.111 46.241 211.525L46.3867 209.615L49.0018 209.815Z",
    fill: "#09003C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M54.727 147.06C54.727 147.06 54.442 151.288 54.3906 151.962C54.3148 152.955 52.2294 151.49 51.6084 150.99C49.3778 149.207 49.5086 148.727 49.4958 148.318L49.6216 146.67L54.7333 147.06L54.727 147.06Z",
    fill: "#E39E76"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4911 138.188C50.1506 138.01 48.3664 140.002 48.1877 142.342L48.0701 143.884C47.8967 146.156 50.5546 148.757 52.8888 148.935L54.8674 149.086C55.4728 149.132 55.6937 148.54 55.7147 148.265C55.7275 148.097 55.799 147.161 55.839 146.636C55.8666 146.274 56.0764 146.159 56.1407 146.138C56.5564 146.038 56.3238 145.713 56.2853 145.559C56.1318 145.02 56.0452 144.675 56.0286 144.152C56.0089 143.423 56.222 142.522 56.1891 142.049C56.0603 140.281 54.8254 138.367 52.4849 138.188L52.4911 138.188Z",
    fill: "#F5BB95"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1936 142.343C48.3722 140.002 49.9692 137.996 52.5282 138.191C54.6627 138.354 56.2005 140.085 56.2012 142.05C56.1844 142.024 54.845 141.231 54.6644 143.596C54.5401 145.225 54.4724 146.03 54.4724 146.03L53.8733 145.984C53.9173 145.736 53.8782 145.426 53.7517 145.109C53.5085 144.512 53.0286 144.137 52.685 144.28C52.3413 144.423 52.2582 145.02 52.5014 145.616C52.6019 145.862 52.7494 146.068 52.9012 146.218C53.2837 146.799 50.971 148.148 50.3919 147.922C50.3919 147.922 47.8998 146.275 48.0822 143.885L48.1998 142.343L48.1936 142.343Z",
    fill: "#09003C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5005 148.017C49.5005 148.017 48.9547 148.176 49.0189 148.734C49.0189 148.734 52.0877 151.379 55.0893 153.918L54.3958 151.9L49.5005 148.017Z",
    fill: "#B2AFD4"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0119 148.733C49.0119 148.733 54.4126 153.151 55.64 154.424C56.2976 155.102 56.5264 157.945 56.2111 162.077C56.1249 163.206 55.9413 173.262 55.9514 176.502C55.9558 178.09 56.067 178.689 54.649 179.008C53.0842 179.359 50.5971 179.703 48.6872 179.557C46.6775 179.404 44.3539 178.592 43.0939 178.157C42.4946 177.948 42.2074 176.941 42.5835 175.714C43.5317 172.585 45.3836 165.758 45.5737 163.267C45.9037 158.942 46.2983 156.486 46.3005 153.743C46.3102 149.914 48.1758 149.077 49.0181 148.734L49.0119 148.733Z",
    fill: "#25216F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3911 151.962C54.3911 151.962 55.4058 152.404 55.6466 154.431L55.0889 153.924C55.0889 153.924 54.6541 152.629 54.3911 151.962Z",
    fill: "#191454"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6197 168.963C50.7957 170.195 51.9359 171.048 53.1672 170.872C54.3985 170.696 55.2514 169.555 55.0754 168.324L53.9767 157.386C53.7519 154.902 52.417 153.639 50.6841 153.889C49.4585 154.072 47.8149 155.127 48.4046 157.846L50.6192 168.97L50.6197 168.963Z",
    fill: "#09003C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1902 181.472C55.5515 182.661 58.9228 181.424 58.5616 180.235L55.1453 168.323C54.7841 167.134 53.5297 166.461 52.3407 166.822C51.1518 167.183 50.4785 168.438 50.8398 169.627L55.1845 181.465L55.1902 181.472Z",
    fill: "#09003C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1214 200.396L66.3754 191.359L67.1499 181.211L51.8959 190.248L51.1214 200.396Z",
    fill: "#8680B6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1212 200.396L49.6283 199.146L50.4023 189.004L51.8957 190.248L51.1212 200.396Z",
    fill: "#766FAC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6562 179.967L67.1491 181.217L51.8951 190.254L50.4023 189.004L65.6562 179.967Z",
    fill: "#B2AFD4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1633 184.219L60.4606 183.638L60.5435 182.552L61.3262 182.085L61.1633 184.219Z",
    fill: "#766FAC"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3201 180.579L62.082 183.699L61.1634 184.219L61.3263 182.085L56.1764 185.157L56.0087 187.354L55.0902 187.874L55.2554 185.708L55.3288 184.747L62.3201 180.579Z",
    fill: "#9490C1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6255 184.166L55.3282 184.747L55.0896 187.874L54.3873 187.287L54.6255 184.166Z",
    fill: "#766FAC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6175 179.991L62.3197 180.579L55.3279 184.753L54.6257 184.166L61.6175 179.991Z",
    fill: "#B2AFD4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6501 193.469L60.1018 193.197L66.9041 184.431L67.1499 181.211L51.8959 190.248L51.6501 193.469Z",
    fill: "#A39DC8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3957 180.919C58.3957 180.919 59.9479 182.545 59.2292 183.406C58.5168 184.268 58.1213 184.433 57.275 184.5C57.275 184.5 57.3658 183.063 56.2972 183.164C56.2972 183.164 55.8525 182.822 55.7953 181.926C55.7953 181.926 57.2365 182.043 58.3895 180.919L58.3957 180.919Z",
    fill: "#F5BB95"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_459_1118",
    x1: 28.774,
    y1: 186.393,
    x2: 80.817,
    y2: 163.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_459_1118",
    x1: 125.957,
    y1: 217.596,
    x2: 127.726,
    y2: 194.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9186BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_459_1118",
    x1: 7.97148,
    y1: 154.861,
    x2: 148.385,
    y2: 162.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_459_1118",
    x1: 96.7265,
    y1: 132.386,
    x2: 54.7152,
    y2: 105.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_459_1118",
    x1: 38.243,
    y1: 159.13,
    x2: 41.622,
    y2: 114.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9186BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_459_1118",
    x1: 99.6767,
    y1: 86.9914,
    x2: 35.1512,
    y2: 80.5353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_459_1118",
    x1: 50.0854,
    y1: 121.256,
    x2: 35.9408,
    y2: 125.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#51509C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6E6BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_459_1118",
    x1: 33.9937,
    y1: 131.227,
    x2: 48.1786,
    y2: 142.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51509C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6E6BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_459_1118",
    x1: 33.3566,
    y1: 131.85,
    x2: 35.5429,
    y2: 103.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#51509C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6E6BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_459_1118",
    x1: 81.7695,
    y1: 96.0709,
    x2: 64.2451,
    y2: 84.9277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_459_1118",
    x1: 45.9492,
    y1: 101.994,
    x2: 46.5927,
    y2: 93.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9186BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_459_1118",
    x1: 90.6073,
    y1: 85.8096,
    x2: 41.3954,
    y2: 80.8863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_459_1118",
    x1: 115.872,
    y1: 194.597,
    x2: 104.706,
    y2: 187.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_459_1118",
    x1: 78.9149,
    y1: 198.06,
    x2: 80.3857,
    y2: 178.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9186BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_459_1118",
    x1: 122.037,
    y1: 177.653,
    x2: 63.2243,
    y2: 171.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_459_1118",
    x1: 129.449,
    y1: 172.82,
    x2: 118.031,
    y2: 165.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_459_1118",
    x1: 102.446,
    y1: 182.153,
    x2: 105.13,
    y2: 146.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9186BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_459_1118",
    x1: 126.203,
    y1: 142.552,
    x2: 87.1838,
    y2: 138.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786FAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_459_1118",
    x1: 110.656,
    y1: 123.097,
    x2: 140.845,
    y2: 74.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E195BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D28BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A16A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#764E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#513645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#33222C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1C1318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0C080A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#030202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_459_1118",
    x1: 110.753,
    y1: 113.358,
    x2: 110.729,
    y2: 113.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_459_1118",
    x1: 113.911,
    y1: 113.069,
    x2: 113.818,
    y2: 113.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_459_1118",
    x1: 103.518,
    y1: 107.354,
    x2: 86.8974,
    y2: 106.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_459_1118",
    x1: 99.6767,
    y1: 108.154,
    x2: 99.1838,
    y2: 108.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_459_1118",
    x1: 99.1242,
    y1: 108.077,
    x2: 98.6809,
    y2: 108.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_459_1118",
    x1: 126.904,
    y1: 133.872,
    x2: 126.674,
    y2: 133.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_459_1118",
    x1: 148.503,
    y1: 140.257,
    x2: 126.675,
    y2: 138.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_459_1118",
    x1: 134.176,
    y1: 150.052,
    x2: 99.4631,
    y2: 111.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#827DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_459_1118",
    x1: 117.073,
    y1: 110.256,
    x2: 97.3803,
    y2: 108.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_459_1118",
    x1: 137.202,
    y1: 121.256,
    x2: 110.728,
    y2: 119.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6D69AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A75B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_459_1118",
    x1: 77.2153,
    y1: 86.9031,
    x2: 41.524,
    y2: 20.1404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E195BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D28BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A16A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#764E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#513645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#33222C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1C1318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0C080A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#030202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSolution);
export default __webpack_public_path__ + "static/media/cloud-solution.f95b4a1d61847edafd405a424c511850.svg";
export { ForwardRef as ReactComponent };